<div
  class="pt-4 pb-12 ps-1 flex flex-col gap-3 bg-white border-r border-gray-300 h-full overflow-y-auto"
  [class.closed]="!navOpen()"
>
  @for (group of navGroups; track $index) {
    <div class="nav-group" [class.expanded]="group.expanded && group.items?.length">
      <div class="nav-group-item" (click)="expandGroup(group)">
        <a
          class="nav-item nav-group-item"
          [routerLink]="group.link"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: !group.items?.length }"
        >
          <fa-icon [icon]="group.icon" />

          <div>{{ group.title }}</div>
        </a>

        @if (group.items?.length) {
          <button mat-icon-button class="small" (click)="toggleGroupExpanded(group); $event.stopPropagation()">
            <fa-icon [icon]="group.expanded ? faChevronDown : faChevronLeft" />
          </button>
        }
      </div>

      @if (group.items?.length && group.expanded) {
        <div class="nav-group-items-container">
          @for (item of group.items; track $index) {
            @if (!item.condition || item.condition()) {
              <a
                class="nav-item"
                [routerLink]="item.link"
                routerLinkActive="active"
                i18n
              >
                {{ item.title }}
              </a>
            }
          }
        </div>
      }
    </div>
  }
</div>
